__turbopack_context__.v({
  "countryCode": "CustomDropdownReferral-module-scss-module__bEShWa__countryCode",
  "darkBg": "CustomDropdownReferral-module-scss-module__bEShWa__darkBg",
  "darkMode": "CustomDropdownReferral-module-scss-module__bEShWa__darkMode",
  "darkText": "CustomDropdownReferral-module-scss-module__bEShWa__darkText",
  "darkspecific": "CustomDropdownReferral-module-scss-module__bEShWa__darkspecific",
  "disabled": "CustomDropdownReferral-module-scss-module__bEShWa__disabled",
  "dropdown": "CustomDropdownReferral-module-scss-module__bEShWa__dropdown",
  "dropdownIcon": "CustomDropdownReferral-module-scss-module__bEShWa__dropdownIcon",
  "dropdownItem": "CustomDropdownReferral-module-scss-module__bEShWa__dropdownItem",
  "dropdownMenu": "CustomDropdownReferral-module-scss-module__bEShWa__dropdownMenu",
  "dropdownMenuWrapper": "CustomDropdownReferral-module-scss-module__bEShWa__dropdownMenuWrapper",
  "dropdownToggle": "CustomDropdownReferral-module-scss-module__bEShWa__dropdownToggle",
  "dropdownToggleCountryCode": "CustomDropdownReferral-module-scss-module__bEShWa__dropdownToggleCountryCode",
  "liContainer": "CustomDropdownReferral-module-scss-module__bEShWa__liContainer",
  "referralCountryCodeDropdown": "CustomDropdownReferral-module-scss-module__bEShWa__referralCountryCodeDropdown",
  "scrollArrow": "CustomDropdownReferral-module-scss-module__bEShWa__scrollArrow",
  "spanWidth": "CustomDropdownReferral-module-scss-module__bEShWa__spanWidth",
});
